module.exports = __webpack_public_path__ + "img/ico_position_header_on.b4852b16.svg";